export const Reload=()=>(
  <svg viewBox="64 64 896 896" style={{marginTop:"3px"}} focusable="false" data-icon="reload" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"></path></svg>
)


export function PlusIcon(props) {
  return (
    <svg data-slot="icon" width={20} fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"></path>
    </svg>
  );
}

export const Reloader =()=>(
  <svg viewBox="64 64 896 896" focusable="false" data-icon="sync" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z"></path></svg>
)


export const CloseSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none">
    <path
      fill="#040707"
      d="M16 1.678 14.389.068 8 6.455 1.611.067 0 1.678l6.389 6.39L0 14.455l1.611 1.611L8 9.678l6.389 6.39L16 14.455 9.611 8.067 16 1.678Z"
    />
  </svg>
);

export const Logout =()=>(
  <svg className="mx-2 cursor-pointer" stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="25px" width="25px" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"></path></svg>
)



export const Vendor = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={"1.4em"}
    height={"1.4em"}
    viewBox="0 0 122.88 120.47"
    style={{ enableBackground: 'new 0 0 122.88 120.47' }}
    xmlSpace="preserve"
    className="ms-1"
  >
    {/* <style type="text/css">{`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}</style> */}
    <g>
      <path
        className="st0"
        d="M54.5,69.81c2.48,5.17,10,5.36,12.38,0.03c-0.65-0.66-1.13-1.36-1.61-2.06c-0.08-0.11-0.16-0.23-0.24-0.34
        c-1.15,0.91-2.54,1.49-4.35,1.49c-1.96-0.01-3.43-0.75-4.64-1.86c-0.07-0.07-0.14-0.13-0.21-0.2c-0.17,0.48-0.39,1.06-0.63,1.59
        C54.98,68.97,54.74,69.46,54.5,69.81L54.5,69.81L54.5,69.81z M115.51,37.52v42.09h5.02c0.82,0,1.5,0.67,1.5,1.49v37.87
        c0,0.82-0.67,1.49-1.5,1.49H1.49c-0.82,0-1.49-0.67-1.49-1.49V81.1c0-0.82,0.67-1.49,1.49-1.49h5.02V36.26
        c-0.5-0.38-0.97-0.79-1.42-1.23c-2.43-2.43-3.93-5.78-3.93-9.46v-5.2l0-0.07v-0.01c0-0.26,0.06-0.52,0.19-0.75L11.88,0.78
        C12.16,0.28,12.68,0,13.21,0l96.78,0c0.61,0,1.13,0.35,1.38,0.86l11.29,18.63c0.14,0.22,0.21,0.47,0.22,0.71l0,0
        c0.01,0.05,0.01,0.1,0.01,0.16v5.2c0,3.68-1.51,7.03-3.93,9.46C117.94,36.03,116.79,36.87,115.51,37.52L115.51,37.52z M103.83,79.61
        V37.7c-1.42-0.67-2.71-1.58-3.8-2.67c-0.96-0.96-1.77-2.06-2.41-3.27c-0.63,1.21-1.45,2.31-2.41,3.27
        c-2.43,2.43-5.78,3.93-9.46,3.93c-3.68,0-7.03-1.51-9.46-3.93c-0.96-0.96-1.77-2.06-2.41-3.27c-0.63,1.21-1.45,2.31-2.41,3.27
        c-2.43,2.43-5.78,3.93-9.46,3.93c-3.68,0-7.03-1.51-9.46-3.93c-0.96-0.96-1.77-2.06-2.41-3.27c-0.63,1.21-1.45,2.31-2.41,3.27
        c-2.43,2.43-5.78,3.93-9.46,3.93c-3.68,0-7.03-1.51-9.46-3.93c-0.96-0.96-1.77-2.06-2.41-3.27c-0.63,1.21-1.45,2.31-2.41,3.27
        c-1.6,1.6-3.59,2.8-5.82,3.43v41.16h19.98c0.19-1.83,1.23-3.94,1.89-4.82c0.6-0.79,1.34-1.37,2.16-1.83
        c2.47-1.37,8.88-1.83,11.54-3.69c0.2-0.29,0.41-0.72,0.61-1.18c0.31-0.7,0.58-1.46,0.76-1.98c-0.75-0.88-1.38-1.87-1.99-2.84
        l-2.02-3.21c-0.74-1.1-1.12-2.11-1.14-2.93c-0.01-0.39,0.05-0.74,0.2-1.05c0.15-0.32,0.38-0.6,0.69-0.81
        c0.15-0.1,0.31-0.18,0.49-0.25c-0.13-1.74-0.18-3.93-0.1-5.77c0.04-0.44,0.13-0.87,0.25-1.31c0.52-1.84,1.81-3.32,3.41-4.34
        c0.88-0.56,1.85-0.99,2.86-1.27c0.64-0.18-0.09-1.62,0.57-1.69c3.2-0.33,7.93,1.99,10.17,4.41c1.12,1.21,1.82,2.82,1.97,4.94
        l-0.13,5.24l0,0c0.56,0.17,0.92,0.52,1.06,1.1c0.16,0.64-0.01,1.53-0.55,2.76l0,0c-0.01,0.02-0.02,0.04-0.03,0.07l-2.3,3.79
        c-0.84,1.39-1.7,2.79-2.82,3.89c0.1,0.14,0.2,0.29,0.3,0.44c0.46,0.67,0.91,1.34,1.5,1.93c0.02,0.02,0.04,0.04,0.05,0.06l0,0
        c2.65,1.87,9.09,2.32,11.56,3.7c0.82,0.46,1.56,1.04,2.16,1.83c0.67,0.88,1.7,2.99,1.89,4.82H103.83L103.83,79.61z M5.24,18.84
        h19.97l3.67-15.79H14.1L5.24,18.84L5.24,18.84z M73.73,3.05l1.53,15.79h20.38L91.47,3.05H73.73L73.73,3.05z M52.91,3.05H34.88
        l3.68,15.79h19.16L52.91,3.05L52.91,3.05z M98.18,18.84h19.47L108.87,3.05H98.18V18.84L98.18,18.84z M122.39,9.57v5.2
        c0,2.5-1.01,4.77-2.66,6.42c-0.65,0.65-1.41,1.21-2.23,1.67V3.05L122.39,9.57L122.39,9.57z M6.51,20.53v17.23
        c0.39,0.34,0.78,0.66,1.2,0.97V3.05L6.51,7.2v5.2C6.51,14.09,6.51,17.44,6.51,20.53L6.51,20.53z M14.85,65.35h17.68
        c1.77,0,3.21,1.43,3.21,3.21v10.15c0,1.77-1.43,3.21-3.21,3.21H14.85c-1.77,0-3.21-1.43-3.21-3.21V68.57
        C11.64,66.8,13.08,65.35,14.85,65.35L14.85,65.35z M90.27,86.9c-0.44,1.64-2.51,1.73-5.07,1.73H37.68c-2.61,0-4.67-0.1-5.07-1.73
        H90.27L90.27,86.9L90.27,86.9z M38.72,96.23H84.3v1.52c0,1.25-0.51,2.39-1.34,3.21c-0.82,0.82-1.96,1.34-3.21,1.34H43.26
        c-1.25,0-2.39-0.51-3.21-1.34c-0.82-0.82-1.34-1.96-1.34-3.21v-1.52L38.72,96.23L38.72,96.23z"
      />
    </g>
  </svg>
);

